import { render, staticRenderFns } from "./BusinessesView.vue?vue&type=template&id=550f71cc&"
import script from "./BusinessesView.vue?vue&type=script&lang=ts&"
export * from "./BusinessesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports